import React from 'react';
import PropTypes from 'prop-types';

export const Table = ({ children }) => (
  <div className="custom-table__wrapper">
    <div className="custom-table">
      {children}
    </div>
  </div>
);

Table.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
}
